import { render } from "./Products.vue?vue&type=template&id=819a59d8&scoped=true"
const script = {}

import "./Products.vue?vue&type=style&index=0&id=819a59d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-819a59d8"

export default script